import { Box, Button, Typography, useTheme } from "@mui/material";
import { ReactElement, useMemo } from "react";
import {
  IoChevronForward,
  IoListOutline,
  IoSettings,
  IoSettingsOutline,
} from "react-icons/io5";
import { StyledIconButton } from "../../atoms/buttons/StyledIconButton";

type CloudCardContentIconType = "navigate" | "settings" | "remove" | "list";

export interface CloudCardContentProps {
  header?: string | ReactElement;
  description?: string | ReactElement;
  avatar?: ReactElement;
  hideAvatar?: boolean;
  iconType?: CloudCardContentIconType;
  wrapperStyle?: any;
  hideIcon?: boolean;
  hideDescription?: boolean;
  onIconClick?: () => void;
  size?: "small";
  iconStyle?: any;
}

export const CloudCardContent = ({
  header,
  description,
  avatar,
  hideAvatar,
  iconType,
  wrapperStyle,
  hideIcon,
  onIconClick,
  iconStyle,
  size,
}: CloudCardContentProps) => {
  const theme = useTheme();
  const icon = useMemo(() => {
    switch (iconType) {
      case "settings":
        return (
          <StyledIconButton>
            <IoSettingsOutline size={18} className="outline-icon" />
            <IoSettings size={18} className="filled-icon" />
          </StyledIconButton>
        );
      case "remove":
        return <Button variant="text">Remove</Button>;
      case "list":
        return <IoListOutline size={18} color={theme.palette.primary.main} />;
      case "navigate":
      default:
        return (
          <IoChevronForward size={18} color={theme.palette.primary.main} />
        );
    }
  }, [iconType]);

  return (
    <Box
      sx={() => ({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        alignSelf: "center",
        padding: "16px",
        flexGrow: 1,
        ...wrapperStyle,
      })}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          flex: 1,
        }}
      >
        {hideAvatar ? null : avatar}
        <Box sx={{ display: "flex", flexDirection: "column" }} component="div">
          <Typography
            component="span"
            sx={{ wordBreak: "break-all", whiteSpace: "normal" }}
          >
            {header}
          </Typography>
          {description ? (
            <Typography
              flexWrap="wrap"
              component="span"
              sx={{ wordBreak: "break-all", whiteSpace: "normal" }}
              variant={size === "small" ? "bodyS" : "body2"}
              color={(theme) => theme.palette.grey[600]}
            >
              {description}
            </Typography>
          ) : null}
        </Box>
      </Box>
      {hideIcon ? null : (
        <StyledIconButton
          onClick={onIconClick}
          sx={() => ({
            svg: {
              height: 18,
              width: 18,
            },
            ...iconStyle,
          })}
        >
          {icon}
        </StyledIconButton>
      )}
    </Box>
  );
};
